


























































































































































































































































































































































































































































































import Vue, { PropType } from 'vue';
import {
  Column,
  ColumnItems,
  ColumnType,
  ExpandRow,
  Row,
} from '@/components/table/types';
import { DropdownList, ObjectValue, PaginationData } from '@/types';
import FieldSelect from '@/components/form/FieldSelect.vue';
import FilterTable from '@/components/table/FilterTable.vue';
import ColumnsTable from '@/components/table/ColumnsTable.vue';
import FieldRadioList from '@/components/form/FieldRadioList.vue';
import Footer from '@/components/table/Footer.vue';
import Panel from '@/components/table/Panel.vue';
import ExpandPanel from '@/components/table/widgets/ExpandPanel.vue';
import ValueTable from '@/components/table/widgets/ValueTable.vue';
import TotalRow from '@/components/table/TotalRow.vue';
import Preloader from '@/components/preloader/Preloader.vue';
import filterParams from '@/components/table/utils/filterParameters';

export default Vue.extend({
  name: 'InventoryTable',
  components: {
    FieldSelect,
    FieldRadioList,
    FilterTable,
    ColumnsTable,
    ValueTable,
    Footer,
    Panel,
    ExpandPanel,
    TotalRow,
    Preloader,
  },
  props: {
    idTable: {
      type: String,
      default: 'table',
    },
    columnsData: {
      type: Array as PropType<Array<Column>>,
    },
    data: {
      type: Array as PropType<Array<Row>>,
    },
    total: {
      type: Object as PropType<Row>,
    },
    expandData: {
      type: Object as PropType<ExpandRow>,
      default: () => {},
    },
    paginationData: {
      type: Object as PropType<PaginationData>,
      default: () => {},
    },
    perPageList: {
      type: Array as PropType<Array<DropdownList>>,
      default: () => [
        { label: '20', value: 20 },
        { label: '50', value: 50 },
        { label: '100', value: 100 },
      ],
    },
    expandColumnIndex: {
      type: String,
      default: 'id',
    },
    expand: {
      type: Boolean,
      default: false,
    },
    disableActions: {
      type: Boolean,
      default: false,
    },
    exportEnable: {
      type: Boolean,
      default: false,
    },
    panelAdvancedEnable: {
      type: Boolean,
      default: true,
    },
    panelEnable: {
      type: Boolean,
      default: true,
    },
    headerEnable: {
      type: Boolean,
      default: true,
    },
    footerEnable: {
      type: Boolean,
      default: true,
    },
    loadData: {
      type: Boolean,
      default: false,
    },
    columnSort: {
      type: String,
      default: null,
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    filterPanelEnable: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.columns = this.columnsData;
    // @ts-ignore
    const column = Vue.localStorage.get(this.storeName);
    const colVisible = JSON.parse(
      column ? decodeURIComponent(window.atob(column)) : column
    );
    if (Array.isArray(colVisible)) {
      colVisible.map((item) => {
        this.columns.find((column: Column, index) => {
          if (column.name == item.name) {
            this.setVisible(index, !!item.visible);
            return true;
          }
          return false;
        });
      });
    }
  },
  watch: {
    columnsData: function(columns: Array<Column>) {
      this.columns = columns;
    },
    paginationData: function(value: PaginationData) {
      this.paginationForm.currentPage = value.currentPage;
      this.paginationForm.totalCount = value.totalCount;
      this.paginationForm.pageCount = value.pageCount;
      this.paginationForm.perPage = value.perPage;
    },
    columnSort(value: string | null) {
      this.sort = value;
    },
  },
  computed: {
    storeName() {
      return '_columnsTable-' + this.idTable;
    },
    getColumns(): Array<Column> {
      return this.columns.filter((columns: Column) => {
        return columns.visible === undefined || columns.visible === true;
      });
    },
    columnsForFilter(): Array<Column> {
      return this.columns.filter((columns: Column) => {
        return (
          columns.type !== ColumnType.TYPE_ACTIONS &&
          columns.type !== ColumnType.TYPE_IMG &&
          (columns.useInFilter === undefined || columns.useInFilter)
        );
      });
    },
  },
  methods: {
    expandIsOpen(row): boolean {
      return (
        this.expand &&
        this.expandRow.includes(row[this.expandColumnIndex]) &&
        this.expandData[row[this.expandColumnIndex]]
      );
    },
    changeExpandPeriod(value: string, row) {
      this.expandPeriod = value;
      this.changeExpand(row);
    },
    openExpand(row: number): boolean {
      if (!this.expand) {
        return false;
      }
      const index: number = this.expandRow.indexOf(row);
      if (index < 0) {
        this.changeExpand(row);
        this.expandRow.push(row);
      } else {
        this.expandRow.splice(index, 1);
      }
      return true;
    },
    changeExpand(row) {
      if (this.expandPeriod) {
        this.filterData['group_by_date'] = this.expandPeriod;
      }
      this.$emit('expand', { index: row, filterData: this.filterData });
    },
    optionsColumn(column: Column) {
      if (column.options) {
        return column.options;
      }
      return {};
    },
    exportData() {
      this.$emit('exportData');
    },
    clickByCell(column: Column, row) {
      row.isCollapse = true;
      this.$emit('clickByCell', { column, row });
    },
    editInventory(index: number) {
      this.$emit('editInventory', this.data[index]);
    },
    deleteInventory(index: number) {
      this.$emit('deleteInventory', this.data[index]);
    },
    addPlacement(index: number) {
      this.$emit('addPlacement', this.data[index]);
    },
    editPlacement(index: number) {
      this.$emit('addPlacement', this.data[index]);
    },
    deletePlacement(inventoryIndex: number, placementId: number) {
      this.$emit('deletePlacement', inventoryIndex, placementId);
    },
    showWidget(placement) {
      this.$emit('showWidget', placement.widget, placement.name);
    },
    changeInventoryStatus(index: number) {
      if (this.data[index].status['value'] === 'active') {
        this.data[index].status['label'] = this.$t(
          'body.table.body.status.stopped'
        );
        this.data[index].status['value'] = 'draft';
      } else {
        this.data[index].status['label'] = this.$t(
          'body.table.body.status.active'
        );
        this.data[index].status['value'] = 'active';
      }
      this.$emit('changeInventoryStatus', this.data[index]);
    },
    changePlacementStatus(inventoryIndex: number, placementIndex) {
      if (
        this.data[inventoryIndex].placements[placementIndex].status['value'] ===
        'active'
      ) {
        this.data[inventoryIndex].placements[placementIndex].status[
          'label'
        ] = this.$t('body.table.body.status.stopped');
        this.data[inventoryIndex].placements[placementIndex].status['value'] =
          'draft';
      } else {
        this.data[inventoryIndex].placements[placementIndex].status[
          'label'
        ] = this.$t('body.table.body.status.active');
        this.data[inventoryIndex].placements[placementIndex].status['value'] =
          'active';
      }

      this.$emit(
        'changePlacementStatus',
        this.data[inventoryIndex].placements[placementIndex]
      );
    },
    addSort(column: Column) {
      if (
        column.type !== this.types.TYPE_ACTIONS &&
        column.type !== this.types.COLUMN_TYPE_IMG
      ) {
        switch (true) {
          case this.sort == column.field: {
            this.sort = '-' + column.field;
            break;
          }
          case this.sort == '-' + column.field: {
            this.sort = '';
            break;
          }
          default:
            this.sort = column.field;
        }
        this.updateQueryStringParameter();
        this.changeTable();
      }
    },
    changePerPage(perPage: number) {
      this.paginationForm.perPage = perPage;
      this.changeTable();
    },
    changeTable() {
      this.$emit(
        'loadData',
        Object.assign(
          {},
          {
            page: this.paginationForm.currentPage,
            per__page: this.paginationForm.perPage,
            sort: this.sort,
          },
          this.filterData
        )
      );
    },
    changeFilter(data) {
      this.filterData = data;
      this.updateQueryStringParameter();
      this.changeTable();
    },
    updateQueryStringParameter() {
      this.filterData['sort'] = this.sort;
      filterParams.toUrl(this.filterData);
    },
    setVisible(index: number, value: boolean) {
      if (this.columns[index].visible == undefined) {
        this.$set(this.columns[index], 'visible', value);
      } else {
        this.columns[index].visible = value;
      }
    },
    changeTotal() {
      this.totalIsOpen = !this.totalIsOpen;
    },
    changeColumn(data) {
      this.columns.find((column: Column, index: number) => {
        if (data.name == column.name) {
          this.setVisible(index, data.visible);
          return true;
        }
        return false;
      });
      const column = JSON.stringify(
        this.columns.map((column: Column) => {
          return {
            name: column.name,
            visible: column.visible === undefined || column.visible === true,
          };
        })
      );
      // @ts-ignore
      Vue.localStorage.set(
        this.storeName,
        window.btoa(encodeURIComponent(column))
      );
    },
    getValue(row: Row, column: Column) {
      if (row[column.field] == undefined) {
        return;
      }
      if (column.items) {
        const value = this.isObjectValue(row[column.field])
          ? (<ObjectValue>row[column.field]).value
          : row[column.field];
        const item: ColumnItems | undefined = column.items.find((item) => {
          return item.value == value;
        });
        if (item) {
          return item.htmlLabel ? item.htmlLabel : item.label;
        }
      }
      if (Array.isArray(row[column.field])) {
        let value: string = '';
        (<Array<string | ObjectValue>>row[column.field]).map(
          (item: string | ObjectValue) => {
            if (value != '') {
              value += ', ';
            }
            if (this.isObjectValue(item)) {
              value += (<ObjectValue>item).label;
            } else {
              value += row[column.field];
            }
          }
        );
        return value;
      }
      return this.isObjectValue(row[column.field])
        ? (<ObjectValue>row[column.field]).label
        : row[column.field];
    },
    isObjectValue(data): boolean {
      if (!data) {
        return false;
      }
      return (
        typeof data === 'object' &&
        !(data instanceof String) &&
        data.hasOwnProperty('value')
      );
    },
    setPage(page: number) {
      this.paginationForm.currentPage = page;
      this.changeTable();
    },
    collapsePlacements(row) {
      if (!row.placements.length) return;

      const index = this.isCollapse.indexOf(row.id);
      if (index > -1) {
        this.isCollapse.splice(index, 1);
      } else {
        this.isCollapse.push(row.id);
      }
    },
  },
  data: function() {
    return {
      loader: null as any,
      sort: null as string | null,
      hoverRow: null as number | null,
      expandRow: [] as Array<number>,
      hoverHeaderColumn: null as number | null,
      filterData: {},
      expandPeriod: 'day',
      columns: [] as Array<Column>,
      totalIsOpen: true,
      paginationForm: {
        totalCount: 100,
        perPage: 20,
        pageCount: 2,
        currentPage: 1,
      } as PaginationData,
      types: {
        COLUMN_TYPE_NUMBER: ColumnType.TYPE_NUMBER,
        COLUMN_TYPE_TEXT: ColumnType.TYPE_TEXT,
        COLUMN_TYPE_LINK: ColumnType.TYPE_LINK,
        COLUMN_TYPE_IMG: ColumnType.TYPE_IMG,
        TYPE_ACTIONS: ColumnType.TYPE_ACTIONS,
      },
      isCollapse: [] as Array<number>,
    };
  },
});
